const utility = {
    toggleClass: function(el, className){
        if (el.classList) {
            el.classList.toggle(className);
        } 
        else {
            var classes = el.className.split(' ');
            var existingIndex = classes.indexOf(className);

            if (existingIndex >= 0) {
                classes.splice(existingIndex, 1);
            }
            else {
                classes.push(className);
            }
            el.className = classes.join(' ');
        }
    },

    addClass: function (el, className) {
        if (!el || !className) return null;

        if (el.classList) {
            if (!el.classList.contains(className)) {
                el.classList.add(className);
            }
        }
        else {
            el.className += ' ' + className;
        }
    },

    removeClass: function(el, className){
        if (el.classList) {
            el.classList.remove(className);
        }
        else {
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    },

    findAncestor: function(el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
    },

    findAncestorType: function (el, type) {
        if (!el || !type) return null;
        while ((el = el.parentElement) && el.nodeName.toLowerCase() !== type);
        return el;
    },

    getOffset: function(element) {
        var top = 0, left = 0;
        do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            element = element.offsetParent;
        } while (element);
        return {
            top: top,
            left: left
        };
    },

    showLoginPopup: function(loginAction, email) {
        const generalError = document.getElementById("authentication--signin-form-general-error");
        if (generalError) {
            generalError.style.display = "none";
        }
        [...document.querySelectorAll("input[name='actionId']")].map(item => {
            item.value = loginAction || "LOG";
        });

        const form = document.getElementById("authentication--signin-form");
        form.querySelector("input[name='username']").value = "";
        form.querySelector("input[name='password']").value = "";
        utility.removeClass(form.querySelector(".account-exists"), 'active');

        utility.removeFormInputErrors(form);
        utility.showPopup(document.querySelector("#authentication--signin-popup"));

        //check for already existing users
        if (loginAction && loginAction == "NAP") {
            form.querySelector("input[name='username']").value = email;
            utility.addClass(form.querySelector(".account-exists"), 'active');
            form.querySelector("input[name='password']").focus();
        }

    },

    showNotificationPopup: function (options) {
        if (options.hideIcon) {
            document.getElementById("global--notification-popup-icon").style.display = "none";
        }
        if (options.title) {
            document.getElementById("global--notification-popup-title").innerHTML = options.title;
        }
        if (options.content) {
            const contentElement = document.getElementById("global--notification-popup-content");
            if (options.content instanceof Element || options.content instanceof HTMLDocument) {
                contentElement.innerHTML = "";
                contentElement.appendChild(options.content);
            }
            else {
                contentElement.innerHTML = options.content;
            }
            if (options.centreContent) {
                contentElement.style.textAlign = "center";
            }
            else {
                contentElement.style.textAlign = "";
            }
        }
        if (options.hideCloseIcon) {
            document.getElementById("global--notification-popup-close").style.display = "none";
        }
        else {
            document.getElementById("global--notification-popup-close").style.display = "";   
        }
        const button = document.getElementById("global--notification-popup-button");
        if (options.button) {
            utility.enableButton(button);
            button.style.display = "";
            if (options.button.text) {
                button.innerHTML = options.button.text;
            }
            else {
                button.innerHTML = "OK";
            }
            if (options.button.clickFunction) {
                button.onclick = () => { 
                    utility.hidePopups();
                    options.button.clickFunction();
                };
            }
            else if (options.button.ajaxOptions) {
                button.onclick = () => {
                    utility.disableButton(button);
                    utility.ajaxRequest(options.button.ajaxOptions);
                };
            }
            else if (options.button.url) {
                button.onclick = () => {
                    window.location.href = options.button.url;
                };
            }
            else {
                button.onclick = () => {
                    utility.hidePopups();
                };
            }
        }
        else {
            button.style.display = "none";
        }
        utility.showPopup(document.getElementById("global--notification-popup"));
    },

    showPendingPopup: function (options) {
        if (options.title) {
            const titleElement = document.getElementById("global--pending-popup-title");
            titleElement.innerHTML = options.title;
        }

        if (options.content) {
            const contentElement = document.getElementById("global--pending-popup-content");
            if (options.content instanceof Element || options.content instanceof HTMLDocument) {
                contentElement.innerHTML = "";
                contentElement.appendChild(options.content);
            }
            else {
                contentElement.innerHTML = options.content;
            }            
        }

        utility.showPopup(document.getElementById("global--pending-popup"));
    },

    showHostedPaymentPopup: function (content) {
        document.querySelector("#global--empty-popup").innerHTML = content;
        utility.showPopup(document.querySelector("#global--empty-popup .hostedpayment-popup"));

        const iframe = document.querySelector("#global--empty-popup .hostedpayment-popup .hostedpayment-frame");
        if (iframe) {
            iframe.addEventListener("load", (e) => {
                const f = e.target;

                if (!f.classList.contains("hostedpayment-frame-loaded") && !f.classList.contains("hostedpayment-frame-started") && !f.classList.contains("hostedpayment-frame-complete")) {
                    utility.addClass(f, "hostedpayment-frame-loaded");
                }
                //The transaction starts proper on the second load.
                else if (f.classList.contains("hostedpayment-frame-loaded") && !f.classList.contains("hostedpayment-frame-started") && !f.classList.contains("hostedpayment-frame-complete")) {
                    utility.addClass(f, "hostedpayment-frame-started");
                    utility.removeClass(f, "hostedpayment-frame-loaded");
                }
            });
        }
    },

    setHostedPaymentPopupComplete: function () {
        const iframe = document.querySelector("#global--empty-popup .hostedpayment-popup .hostedpayment-frame");
        if (iframe) {
            if (!iframe.classList.contains("hostedpayment-frame-complete")) {
                utility.addClass(iframe, "hostedpayment-frame-complete");

                if (iframe.classList.contains("hostedpayment-frame-loaded")) {
                    utility.removeClass(iframe, "hostedpayment-frame-loaded");
                }

                if (iframe.classList.contains("hostedpayment-frame-started")) {
                    utility.removeClass(iframe, "hostedpayment-frame-started");
                }
            }            
        }
    },

    showContentPopup: function(content, refreshUrl) {
        document.querySelector("#global--empty-popup").innerHTML = content;
        const closeButton = document.querySelector("#global--empty-popup .popup-close");
        if (closeButton) {
            closeButton.onclick = () => {
                [...document.querySelectorAll(".popup")].map(popup => {
                    popup.classList.remove("active");
                    utility.htmlScroll("initial");
                });
                if (refreshUrl) {
                    window.location.href = refreshUrl;

                }
            };
        }
        utility.showPopup(document.querySelector("#global--empty-popup > .popup"));
    },

    showPopup: function (el) {
        if (el.classList.contains("active")) {
            return;
        }
        [...document.querySelectorAll('.popup')].map(popup => {
            popup.classList.remove('active');
        });
        [...document.querySelectorAll('.hostedpayment-popup')].map(popup => {
            popup.classList.remove('active');
        });
        if (el) {
            utility.addClass(el, 'active');
            utility.addClass(document.body, 'popup-active');
            utility.htmlScroll('hidden');
            const container = el.querySelector(".popup-container");
            if (container) {
                container.scrollTop = 0;
            }
        }
    },

    hidePopups: function() {
        [...document.querySelectorAll('.popup')].map(popup => {
            popup.classList.remove('active');
        });
        [...document.querySelectorAll('.hostedpayment-popup')].map(popup => {
            popup.classList.remove('active');
        });
        utility.htmlScroll('initial');
    },

    disableButton: function(el) {
        if (el) {
            el.disabled = true;
            utility.addClass(el, "loading");
        }
    },
     
    enableButton: function(el) {
        if (el) {
            el.disabled = false;
            utility.removeClass(el, "loading");
        }
    },

    htmlScroll: function(state)  {
        const body = document.body;
        if (state === 'hidden') {
            if (window.innerWidth < 760) {
                document.documentElement.style.position = 'fixed';
            }
            body.style.overflow = 'hidden';
            body.classList.add('scroll-hidden');
            return;
        }
        if (state === 'initial') {
            if (window.innerWidth < 760) {
                document.documentElement.style.position = 'static';
            }
            body.style.overflow = 'scroll';
            body.classList.remove('scroll-hidden');
            body.classList.remove('popup-active');
            return;
        }
        body.style.overflow = body.style.overflow === 'hidden' ? 'initial' : 'hidden';
    },

    getFormData: function(el) {
        var formData = "";
        for (var i = 0; i < el.elements.length; i++) {
            var d = el.elements[i];
            if (d.name && d.value) {
                var v = (d.type == "checkbox" || d.type == "radio" ? (d.checked ? d.value : '') : d.value);
                if (v) {
                    formData += d.name + "=" + encodeURIComponent(v) + "&";
                }
            }
        }
        return formData;
    },

    addFormInputErrors: function(form, fieldErrors) {
        fieldErrors.map(error => {
            utility.addFormInputError(form, error.Name, error.Error);
        });
    },

    addFormInputError: function(form, name, error) {
        [...form.querySelectorAll("[name=" + name + "]")].map(input => {
            if (input.tagName === "SELECT") {
                input.nextSibling.classList.add("has-error");
            }
            else if (input.tagName === "INPUT" && input.type === "radio") {
                utility.findAncestor(input, "radio-container").classList.add("has-error");
            }
            else {
                input.parentNode.classList.add("has-error");
            }
            let errorNode = input.parentNode.querySelector(".input-error");
            if (!errorNode) {
                errorNode = document.getElementById(input.dataset.error);
            }
            if (errorNode) {
                errorNode.style.display = "";
                errorNode.innerHTML = error;
            }
        });
    },

    removeFormInputErrors: function(form) {
        [...form.querySelectorAll(".has-error")].map(item => { item.classList.remove("has-error"); });
        [...form.querySelectorAll(".input-error")].map(item => { item.style.display = "none"; });
    },

    scrollToFormError: function (form, fieldErrors) {
        for (let e = 0; e < fieldErrors.length; e++) {
            const errorProp = fieldErrors[e].Name;
            let element = form.querySelector(`[name='${errorProp}']`);
            if (element && element.nodeName && element.nodeName.toLowerCase() === "select") {
                element = element.nextElementSibling;
            }
            if (element) {
                element.scrollIntoView();
                return;
            }
        }
    },

    validateNumber: function(keydownEvent) {
        if (keydownEvent.shiftKey) {
            return false;               
        }
        const isValidChar = 
            // numpad 0-9
            (keydownEvent.keyCode > 95 && keydownEvent.keyCode < 106) || 
            // keyboard 0-9
            (keydownEvent.keyCode > 47 && keydownEvent.keyCode < 58) || 
            // pgup/pgdown/home/end/arrows
            (keydownEvent.keyCode > 32 && keydownEvent.keyCode < 41) ||
            // backspace/delete/tab/escape
            (keydownEvent.keyCode == 8 || keydownEvent.keyCode == 46 || keydownEvent.keyCode == 9 || keydownEvent.keyCode == 27);
        return isValidChar;
    },

    ajaxRequest: function(options) {
        const xhr = new XMLHttpRequest();
        xhr.open(options.method, options.url, true);
        xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        if (options.contentType === undefined && typeof options.contentType === "undefined") {
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        }
        else if (options.contentType !== null) {
            xhr.setRequestHeader("Content-Type", options.contentType);
        }
        if (options.responseType) {
            xhr.responseType = options.responseType;
        }
        xhr.onreadystatechange = function(e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    let isUnauthorised = false;
                    try {
                        const jsonResult = JSON.parse(e.target.responseText);
                        if (jsonResult.unauthorised) {
                            isUnauthorised = true;
                        }
                    }
                    catch(err) {
                        isUnauthorised = false;
                    }
                    if (isUnauthorised) {
                        utility.showLoginPopup();
                    }
                    else if (options.success) {
                        options.success(e);
                    }
                }
                else {
                    if (options.error) {
                        options.error(e);
                    }
                }
                if (options.always) {
                    options.always(e);
                }
            }
        };
        if (options.data) {
            xhr.send(options.data);
        }
        else {
            xhr.send(null);
        }
    },

    copyTextToClipboard: function (text, copySuccess, copyError) {
        if (!navigator.clipboard) {
            utility.fallbackCopyTextToClipboard(text, copySuccess, copyError);
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
            if (copySuccess) {
                copySuccess();
            }
        }, function (err) {
            if (copyError) {
                copyError();
            }
        });
    },

    fallbackCopyTextToClipboard: function (text, copySuccess, copyError) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            if (document.execCommand("copy")) {
                if (copySuccess) {
                    copySuccess();
                }
            }
            else if (copyError) {
                copyError();
            }
        }
        catch (err) {
            if (copyError) {
                copyError();
            }
        }
        document.body.removeChild(textArea);
    },

    logInfo: function(message, callback) {
        utility.log(message, "I", callback);
    },

    logWarn: function(message, callback) {
        utility.log(message, "W", callback);
    },
    logError: function (message, error, callback) {
        try {
            if (error && error.message) {
                const msg = `${message}: ${error.message}`;
                utility.log(msg, "E", callback);  // Pass the callback to the log function
            }
            else {
                utility.log(message, "E", callback);  // Pass the callback to the log function
            }
        }
        catch (error) {
            if (callback) {
                callback();  // Ensure the callback is called even if an error occurs
            }
        }
    },


    log: function (message, level, callback) {
        try {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", "/services/log-message", true);
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            xhr.responseType = "text";
            xhr.onreadystatechange = function (e) {
                if (xhr.readyState === 4 && xhr.status === 200) {
                    if (callback) {
                        const popupContainer = document.querySelector('.popup-container > .container');
                        const popupInner = document.querySelector('.popup-inner');

                        // Apply the styles dynamically
                        if (popupContainer) {
                            popupContainer.style.maxWidth = '42rem';
                        }

                        if (popupInner) {
                            popupInner.style.maxWidth = '42rem';
                        }
                        callback();  // Call the callback function after successful logging
                    }
                }
            };
            xhr.send("message=" + encodeURIComponent(message) + "&level=" + encodeURIComponent(level));
        }
        catch (error) {
            if (callback) {
                callback();  // Ensure the callback is called even if an error occurs
            }
        }
    }

}

export default utility




// WEBPACK FOOTER //
// ./assets/src/js/classes/utility.js